module.exports = __webpack_public_path__ + "static/media/banner-img.45c429ec.svg";